import type { SongSettingsValue } from '@/components/ui/SongSettings.vue'

const MOOD_VALUES = [
	'joy',
	'sadness',
	'inspiration',
	'melancholy',
	'tenderness',
	'romance',
	'calm',
	'anxiety',
	'happiness',
	'anger'
]
const GENRE_VALUES = ['electronic', 'rock', 'soundtrack', 'hip-hop', 'pop', 'ballad', 'folk', 'lo-fi', 'dance', 'metal']
const VOCAL_VALUES = ['male vocal', 'female vocal']
const TEMPO_VALUES = ['slow', 'moderate', 'fast']

export function parseSongStyle(style: string): SongSettingsValue {
	const tokens = style.split(',').map((s) => s.trim().toLowerCase())
	return {
		moods: tokens.filter((t) => MOOD_VALUES.includes(t)),
		genres: tokens.filter((t) => GENRE_VALUES.includes(t)),
		vocal: tokens.find((t) => VOCAL_VALUES.includes(t)) ?? '',
		tempo: tokens.find((t) => TEMPO_VALUES.includes(t)) ?? ''
	}
}
